import useTrackNativePrintEvents from "./useTrackNativePrintEvents";

const GlobalEventsHandler = () => {
  useTrackNativePrintEvents();
  return null;
};

export default GlobalEventsHandler;
